function Card(props) {
  const { variant, extra, children, ...rest } = props;
  
  return (
    <div
      className={`card glass-card border ${extra}`}
      {...rest}
    >
      {children}
    </div>
  );
}

export default Card;
